import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/ui/Layout.vue'
import UILayout from '@/components/ui/UILayout.vue'
import OrgLayout from '@/components/ui/OrgLayout.vue'

Vue.use(Router)
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [{
      // 一级路由-前台母版页（头尾）
      path: '/',
      component: Layout,
      children: [
        // 二级登录页面
        {
          name: 'login',
          path: '/',
          meta: {
            title: '登录'
          },
          component: () =>
            import('@/views/login/login'),
        },
        // 三级-机构中心
        {
          name: 'org',
          path: '/org',
          component: OrgLayout,
          children: [{
              path: '/org',
              name: 'index',
              component: () =>
                import('@/views/org/index'),
              meta: {
                title: '应聘信息'
              }
            },
            {
              path: '/org/jianli',
              name: 'orgJl',
              component: () =>
                import('@/views/org/jianli'),
              meta: {
                title: '求职信息'
              }
            },
          ],

        },
        {
          // 二级登录后，个人中心母版页(顶部用户状态)
          path: '/zhaopin',
          component: UILayout,
          children: [{
              path: '/zhaopin',
              name: 'index',
              component: () =>
                import('@/views/ZhaoPin/index'),
              meta: {
                title: '首页'
              },
            },
            // 三级-个人中心
            {
              path: '/zhaopin/detail',
              name: 'zpdetail',
              component: () =>
                import('@/views/ZhaoPin/detail'),
              meta: {
                title: '招聘详情页'
              },
            },
          ]
        },
        {
          // 二级登录后，个人中心母版页(顶部用户状态)
          path: '/yingpin',
          component: UILayout,
          children: [
            // 三级-个人中心
            {
              path: '/yingpin',
              name: 'index',
              component: () =>
                import('@/views/yingpin/Index'),
              meta: {
                title: '简历详情页'
              },
            },
          ]
        },
        {
          // 二级登录后，个人中心母版页(顶部用户状态)
          path: '/jianli',
          component: UILayout,
          children: [
            // 三级-个人中心
            {
              path: '/jianli',
              name: 'index',
              component: () =>
                // import ('@/views/JianLi/JlIndex'),
                import('@/views/JianLi/Index'),
              meta: {
                title: '简历详情页'
              },
            },
          ]
        },
        {
          // 获奖证书
          path: '/AwardRecord',
          component: UILayout,
          children: [
            // 三级-个人中心
            {
              path: '/AwardRecord',
              name: 'AwardRecord',
              component: () =>
                // import ('@/views/JianLi/JlIndex'),
                import('@/views/AwardRecord'),
              meta: {
                title: '获奖证书查询'
              },
            },
          ]
        },
      ]
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js